// extracted by mini-css-extract-plugin
module.exports = {"root":"images-module--root--3ejpO","fullWidth":"images-module--fullWidth--3VZpQ","twoColumns":"images-module--twoColumns--qN7fU"};